import { defineStore } from "pinia";
import http from "@/http";
import { debounce } from "lodash-es";

export const usePushesStore = defineStore("pushes", {
  state: () => ({
    pushes: [],
    searchQuery: "",
    loading: false,
    error: null,
    selectedType: 'all',
    selectedCount: 100,
    isInitialLoad: true,
    isRefreshing: false,
  }),

  getters: {
    pushesCount: (state) => state.filteredItems.length,

    filteredByType: (state) => {
      if (state.selectedType !== "all") {
        return state.pushes.filter(push => push.type === state.selectedType);
      }
      return state.pushes;
    },

    filteredItems(state) {
      let items = state.pushes;

      // Фильтр по типу
      if (state.selectedType !== "all") {
        items = items.filter(push => push.type === state.selectedType);
      }

      // Поиск
      if (state.searchQuery && state.searchQuery.trim() !== "") {
        const query = state.searchQuery.toLowerCase();
        items = items.filter(
            (push) =>
                (push.message && push.message.toLowerCase().includes(query)) ||
                (push.order && push.order.toLowerCase().includes(query)) ||
                (push.truckNumber && push.truckNumber.toLowerCase().includes(query))
        );
      }

      // Количество
      if (state.selectedCount !== 'all') {
        const count = parseInt(state.selectedCount);
        if (!isNaN(count)) {
          return items.slice(0, count);
        }
      }

      return items;
    },
  },

  actions: {
    debouncedFetchPushes: debounce(async function () {
      await this.fetchPushes();
    }, 300),

    async fetchPushes() {
      this.loading = true;
      this.error = null;

      try {
        // const params = this.buildQueryParams();
        const response = await http.get("/api/dispatcher/pushes?count=1000");

        if (response.status === 200 && response.data) {
          this.pushes = response.data.map((push) =>
            this.parsePushMessage(push)
          );

          // console.log("Pushes fetched successfully:", this.pushes);
        }
      } catch (error) {
        this.error = error.message || "Ошибка при загрузке пушей";
        console.error("Error fetching orders:", error);
      } finally {
        this.loading = false;
      }
    },

    parseLostPush(push) {
      const msgText = push.message;
      const timeMatch = msgText.match(
        /с (\d{2}-\d{2}-\d{4} \d{2}:\d{2}:\d{2})/
      );
      const orderMatch = msgText.match(/Активный заказ: (\d+)/);

      return {
        ...push,
        offlineTime: timeMatch?.[1] || "",
        order: orderMatch?.[1] || push.order,
      };
    },

    parseRegainedPush(push) {
      const msgText = push.message;
      const timeMatch = msgText.match(
        /с (\d{2}-\d{2}-\d{4} \d{2}:\d{2}:\d{2})/
      );
      const orderMatch = msgText.match(/Активный заказ: (\d+)/);

      return {
        ...push,
        onlineTime: timeMatch?.[1] || "",
        order: orderMatch?.[1] || push.order,
      };
    },

    parseLoadingPush(push) {
      const msgText = push.message;
      const busyOrderMatch = msgText.match(/более чем на (\d+)/);
      const truckMatch = msgText.match(/Перевозчик: (\d+)/);

      return {
        ...push,
        busyOrder: busyOrderMatch?.[1] || "",
        truckplate: truckMatch?.[1] || "",
      };
    },

    parsePushMessage(push) {
      if (push.type === "pushLostConnection") {
        return this.parseLostPush(push);
      } else if (push.type === "pushLoadingDelay") {
        return this.parseLoadingPush(push);
      } else if (push.type === "pushRegainedConnection") {
        return this.parseRegainedPush(push);
      }

      // Возвращаем оригинальный push, если тип не распознан
      return push;
    },

    formatLoadingTime(order) {
      return order.loadingTime || "-";
    },

    formatDeliveryTime(order) {
      return order.deliveryTime || "-";
    },

    searchPushes(query) {
      this.searchQuery = query;
    },

    setSelectedType(type) {
      this.selectedType = type;
    },

    setCount(newCount) {
      this.selectedCount = newCount;
    },

    clearAllFilters() {
      this.selectedCount = 100;
      this.selectedType = 'all';
      this.searchQuery = '';
    },
  },
});
